import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { getDummyText } from "../../../utils";

export const dummyIcons = [
    {
        title: "Internationales arbeiten",
        bodyText: getDummyText(100),
        iconName: "globe-circle-arrows",
    },
    {
        title: "Entwicklungsmöglichkeiten",
        bodyText: getDummyText(50),
        iconName: "signpost",
    },
    {
        title: "Weitere Leistungen und Angebote und ein bisschen mehr Text",
        bodyText: getDummyText(60),
        iconName: "lightbulb",
    },
    {
        title: "Zusatzleistungen",
        bodyText: getDummyText(80),
        iconName: "hand-plus",
    },
    {
        title: "Gebrauchtmachine des monats",
        bodyText: getDummyText(30),
        iconName: "machine",
    },
];

const renderTitle = (title: string) => html`
    <div slot="title" class="ux-text-normal ux-u-text-bold">
        <strong>${title}</strong>
    </div>
`;

const renderBodyText = (text: string) => html`
    <div
        slot="text"
        class="ux-text-normal ux-text-normal--light-gray ux-u-margin-top-5 ux-u-margin-children-0"
    >
        <p>${text}</p>
    </div>
`;

const renderLink = (url: string = "#", text: string = "Mehr erfahren") => html`
    <div slot="link">
        <a href="${url}" class="ux-text-link ux-text-link--green">
            ${text}
            <ux-icon name="arrow-small-right" />
        </a>
    </div>
`;

interface IconGridItemProps {
    iconName: string;
    teaserColor?: string;
    title: string;
    bodyText?: string;
    linkUrl?: string;
    linkText?: string;
}

export const IconGridItemTemplate = (args: IconGridItemProps) => html`
    <ux-iws-teaser-icon
        icon-name="${args.iconName}"
        shadow="false"
        variant="icon-box"
        teaser-color=${ifDefined(args.teaserColor)}
    >
        ${args.title && renderTitle(args.title)}
        ${args.bodyText && renderBodyText(args.bodyText)}
        ${args.linkUrl && renderLink(args.linkUrl, args.linkText)}
    </ux-iws-teaser-icon>
`;

interface IconGridTemplateProps {
    background?: string;
    containerClassName?: string;
    items: IconGridItemProps[];
    media?: string;
}

const defaultStoryArgs: IconGridTemplateProps = {
    background: "",
    containerClassName: "",
    items: dummyIcons.slice(3),
    media: "",
};

export const IconGridTemplate = (props: IconGridTemplateProps) => {
    const args: IconGridTemplateProps = {
        ...defaultStoryArgs,
        ...props,
    };
    const rowClassNames = ["ux-row"];
    if (args.background !== "") {
        rowClassNames.push(args.background);
    }
    if (args.containerClassName !== "") {
        rowClassNames.push(args.containerClassName);
    }
    const gridClassNames = ["ux-iws-teaser-icon-grid"];
    if (args.background !== "") {
        gridClassNames.push("ux-iws-teaser-icon-grid--with-background");
    }
    if (args.items.length === 5) {
        gridClassNames.push("ux-iws-teaser-icon-grid--five-elements");
    }
    if (args.media !== "") {
        gridClassNames.push("ux-iws-teaser-icon-grid--mq");
    }
    return html`
        <div
            class="${rowClassNames.join(" ")}"
            style="container-type: inline-size;"
        >
            <div class="ux-col-10 ux-u-offset-1">
                <div class="${gridClassNames.join(" ")}">
                    ${args.items.map((item) => {
                        return IconGridItemTemplate({
                            ...item,
                        });
                    })}
                </div>
            </div>
        </div>
    `;
};
